import isEmpty from "lodash/isEmpty";

export const getUpdatedDummyStoreFields = (dummyStore, withTaxons = true) => {
  if (isEmpty(dummyStore)) return {};
  const { name, logo, taxonIds, topBanner } = dummyStore;
  return {
    name,
    ...(logo && { logo }),
    dummyStore,
    ...(withTaxons && { taxonIds }),
    ...(topBanner && { topBanner, mobileTopBanner: topBanner }),
  };
};
